import React, { useEffect, useState } from "react";
import CustomTable from "../../../shared/custom-table/custom-table";
import { D17, MobilePay, Poste } from "../../../assets/images";
import {
  columnsRequestsCurrentStudent,
  columnsRequestsCurrentTeacher,
} from "../../../mocks/fakeData";
import { getAllStudentCurrentRequests } from "../../../services/student-offer";
import { RootState } from "../../../redux/store/store";
import { useSelector } from "react-redux";
import { getCurrentTeacherRequests } from "../../../services/teacher-offer";

const Subscription = () => {
  const role = useSelector(
    (state: RootState) => state?.user?.userData?.role.name,
  );
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (role === "ROLE_STUDENT") {
      getAllStudentCurrentRequests()
        .then((res) => {

          res.data = res.data.map((item: any) => {
            return {
              ...item,
              endDate: item.status === "PENDING" ? "N/A" : item.endDate,
            };
          });

          setData(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      getCurrentTeacherRequests()
        .then((res) => {
          console.log(res);
          setData(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [role]);

  const ActionButtons: React.FC<{ row: any }> = ({ row }) => {
    // Get today's date without time for comparison
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    // Check if endDate is a valid date
    const isValidDate = row.endDate && !isNaN(new Date(row.endDate).getTime());
    const endDate = isValidDate ? new Date(row.endDate) : null;
    console.log(endDate);
    console.log(today);
    return (
      <div className="flex items-center justify-center space-x-2">
        {endDate && (endDate < today && row.status === 'ACCEPTED') ? (
          <p className="cursor-pointer bg-[#808080] text-white font-montserrat_regular rounded-full px-5 ms-1">
            Expirée
          </p>
        ) : row.status === "ACCEPTED" ? (
          <p className="px-5 text-white rounded-full cursor-pointer bg-primary_bg font-montserrat_regular">
            Acceptée
          </p>
        ) : row.status === "REJECTED" ? (
          <p className="px-5 text-white rounded-full cursor-pointer bg-red font-montserrat_regular ms-1">
            Rejetée
          </p>
        ) : (
          <p className="px-5 text-white rounded-full cursor-pointer bg-text font-montserrat_regular ms-1">
            Pending
          </p>
        )}
      </div>
    );
  };
  

  const renderActions = (row: any) => <ActionButtons row={row} />;

  return (
    <div className="w-full p-3">
      <p className="mb-10 text-3xl text-title font-montserrat_bold">
        Abonnement
      </p>
      {/* Payment Methods Grid */}
      <div className="grid grid-cols-1 gap-6 px-5 mb-10 md:grid-cols-2 md:px-10">
        {/* BNA Bank Card */}
        <div className="bg-gradient-to-br from-[#1a5f7a] to-[#2d8ba8] rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
          <div className="flex items-start justify-between mb-6">
            <div>
              <h3 className="mb-1 text-xl text-white font-montserrat_bold">BNA</h3>
              <p className="text-sm text-white/80 font-montserrat_medium">Banque Nationale Agricole</p>
            </div>
            <div className="flex items-center justify-center w-16 h-16 p-2 bg-white shadow-lg rounded-xl">
              <img src={MobilePay} alt="Mobile Pay" className="object-contain w-full h-full" />
            </div>
          </div>
          <div className="space-y-3">
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">Titulaire</p>
              <p className="text-sm text-white font-montserrat_semi_bold">Omar Riahi</p>
            </div>
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">RIB</p>
              <p className="text-sm tracking-wider text-white font-montserrat_semi_bold">03 200 012 0112 000 266 51</p>
            </div>
          </div>
        </div>

        {/* La Poste D17 Card */}
        <div className="bg-gradient-to-br from-[#f59e0b] to-[#d97706] rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
          <div className="flex items-start justify-between mb-6">
            <div>
              <h3 className="mb-1 text-xl text-white font-montserrat_bold">La Poste</h3>
              <p className="text-sm text-white/80 font-montserrat_medium">Compte D17</p>
            </div>
            <div className="flex items-center justify-center w-16 h-16 p-2 bg-white shadow-lg rounded-xl">
              <img src={D17} alt="D17" className="object-contain w-full h-full" />
            </div>
          </div>
          <div className="space-y-3">
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">Titulaire</p>
              <p className="text-sm text-white font-montserrat_semi_bold">Riahi Omar</p>
            </div>
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">Numéro D17</p>
              <p className="text-sm tracking-wider text-white font-montserrat_semi_bold">4742 0140 4391 9147</p>
            </div>
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">Téléphone D17</p>
              <p className="text-sm text-white font-montserrat_semi_bold">22 946 781</p>
            </div>
          </div>
        </div>

        {/* La Poste RIB Card */}
        <div className="bg-gradient-to-br from-[#0f3460] to-[#16213e] rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
          <div className="flex items-start justify-between mb-6">
            <div>
              <h3 className="mb-1 text-xl text-white font-montserrat_bold">La Poste</h3>
              <p className="text-sm text-white/80 font-montserrat_medium">Compte Courant</p>
            </div>
            <div className="flex items-center justify-center w-16 h-16 p-2 bg-white shadow-lg rounded-xl">
              <img src={Poste} alt="La Poste" className="object-contain w-full h-full" />
            </div>
          </div>
          <div className="space-y-3">
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">Titulaire</p>
              <p className="text-sm text-white font-montserrat_semi_bold">Riahi Omar</p>
            </div>
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">RIB</p>
              <p className="text-sm tracking-wider text-white font-montserrat_semi_bold">17 002000000 3493 484 56</p>
            </div>
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">Numéro de Compte</p>
              <p className="text-sm tracking-wider text-white font-montserrat_semi_bold">03 49 34 84 56</p>
            </div>
          </div>
        </div>

        {/* Address Card */}
        <div className="bg-gradient-to-br from-[#16a34a] to-[#15803d] rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
          <div className="flex items-start justify-between mb-6">
            <div>
              <h3 className="mb-1 text-xl text-white font-montserrat_bold">Centre intellect</h3>
              <p className="text-sm text-white/80 font-montserrat_medium">Notre Adresse</p>
            </div>
            <div className="flex items-center justify-center w-16 h-16 p-2 bg-white shadow-lg rounded-xl">
              <img src="https://cdn-icons-png.flaticon.com/512/684/684908.png" alt="Location" className="object-contain w-full h-full" />
            </div>
          </div>
          <div className="space-y-3">
            <div className="p-3 rounded-lg bg-white/10 backdrop-blur-sm">
              <p className="mb-1 text-xs text-white/70 font-montserrat_medium">Adresse</p>
              <p className="text-sm leading-relaxed text-white font-montserrat_semi_bold">
                شارع حسن النوري مقابل المنقالة<br />فوق حمادي عبيد<br />Centre intellect
              </p>
            </div>
          </div>
        </div>
      </div>
      <CustomTable
        title="Liste des Abonnement"
        columns={
          role === "ROLE_STUDENT"
            ? columnsRequestsCurrentStudent
            : columnsRequestsCurrentTeacher
        }
        data={data}
        actions={renderActions}
      />
      <div className={"h-10"}></div>
    </div>
  );
};

export default Subscription;
